export default __webpack_public_path__ + "static/media/pizap_watermark.bac4ad82.png";